module.exports = __webpack_public_path__ + "img/image16714467906199521256408@1x.1766e7e6.webp";